var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { usePopper } from '@betterfunnel/react-use-popper-hook';
import { MenuButton as ButtonMenuButton, Menu, MenuItem, MenuItems, Portal, Transition, } from '@headlessui/react';
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid';
import React, { Fragment, createElement, useMemo, } from 'react';
import { uid } from 'uid';
import { classNames } from './utils';
export default function MenuButton(_a) {
    var { items, placement, disabled } = _a, props = __rest(_a, ["items", "placement", "disabled"]);
    const [trigger, container] = usePopper({
        placement: placement !== null && placement !== void 0 ? placement : 'bottom-start',
        strategy: 'fixed',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 10],
                },
            },
        ],
    });
    const itemsWithIds = useMemo(() => items.map((item) => (Object.assign(Object.assign({}, item), { id: item.id || uid(6) }))), [items]);
    return (_jsx(Menu, { as: "div", className: "relative inline-block text-left", "aria-disabled": disabled ? 'true' : undefined, children: ({ open }) => (_jsxs(_Fragment, { children: [_jsx("div", { children: 'customButton' in props ? (_jsxs(ButtonMenuButton, { as: "div", disabled: disabled, ref: trigger, children: [_jsx("span", { className: "sr-only", children: "Open options" }), typeof props.customButton === 'function'
                                ? props.customButton({ open })
                                : props.customButton] })) : (_jsxs(ButtonMenuButton, { ref: trigger, disabled: disabled, onClick: (e) => {
                            e.stopPropagation();
                        }, className: classNames('flex items-center rounded-full p-1 text-gray-600 hover:bg-gray-100 hover:text-gray-700 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-100 focus:outline-hidden', props.buttonClassName), children: [_jsx("span", { className: "sr-only", children: "Open options" }), _jsx(EllipsisVerticalIcon, { className: "h-5 w-5", "aria-hidden": "true" })] })) }), _jsx(Portal, { children: _jsx(Transition, { as: Fragment, enter: "transition-opacity ease-out duration-100", enterFrom: "transform opacity-0 scale-95", enterTo: "transform opacity-100 scale-100", leave: "transition-opacity ease-in duration-75", leaveFrom: "transform opacity-100 scale-100", leaveTo: "transform opacity-0 scale-95", children: _jsx(MenuItems, { ref: container, className: classNames('z-[9999] mt-2 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-hidden'), onClick: (e) => {
                                e.stopPropagation();
                            }, children: _jsx("div", { className: "py-1 text-start text-sm", children: itemsWithIds.map((item) => (_jsx(_MenuOption, { option: item }, item.id))) }) }) }) })] })) }));
}
const _MenuOption = ({ option }) => {
    switch (option.type) {
        case 'divider':
            return _jsx("div", { className: "h-px bg-gray-100" });
        case 'content':
            return option.child;
        default:
            return (_jsx(MenuItem, { disabled: option.disabled, children: ({ disabled }) => (_jsxs("button", { disabled: disabled, onClick: option.onClick, className: classNames('group', option.destructive
                        ? 'text-red-500 hover:bg-gray-100 hover:text-red-600 disabled:bg-transparent'
                        : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900 disabled:bg-transparent', 'flex w-full items-center px-4 py-2 whitespace-nowrap'), children: [option.icon ? (_jsx("span", { className: classNames(option.destructive
                                ? 'text-red-400 group-hover:text-red-500'
                                : 'text-gray-400 group-hover:text-gray-500', 'me-3 flex h-5 w-5 items-center justify-start'), children: React.isValidElement(option.icon)
                                ? option.icon
                                : createElement(option.icon, {
                                    'aria-hidden': 'true',
                                }) })) : undefined, option.title] })) }));
    }
};
